import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  inject,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
} from '@ionic/angular/standalone';
import { AuthenticationService } from 'src/app/core/auth/authentication/authentication.service';
import { IMAGE_SRC } from '../shared/shared-constants';
import { LoginErrorBannerComponent } from './login-error-banner/login-error-banner.component';
import { CONSTS, Web_Access_Steps } from './login.constants';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';

@Component({
  selector: 'app-login',
  imports: [
    IonButton,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonCardContent,
    LoginErrorBannerComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  newUserTemplate = viewChild('newUser', { read: TemplateRef });
  currentUserTemplate = viewChild('currentUser', { read: TemplateRef });

  private authService = inject(AuthenticationService);
  route = inject(ActivatedRoute);
  private readonly commonUtils = inject(CommonUtils);

  readonly CONSTS = CONSTS;
  readonly IMAGES = IMAGE_SRC;

  continue() {
    this.authService.loginInteractively();
  }

  async downloadAccessSteps() {
    this.commonUtils.convertBase64toPdf(Web_Access_Steps, 'GPD_Web_Access_Steps');
  }

  get hasLoginError() {
    return this.route.snapshot.queryParamMap.get('userId');
  }
}
